import * as React from "react";
import { Option } from "@nozzlegear/railway";
import { Maybe } from "@nozzlegear/railway-react";

type Props = {
    error: string | null | undefined | Option<string>;
};

export function MaybeError({ error }: Props): JSX.Element {
    const optValue = React.useMemo<Option<string>>(
        () => (error instanceof Option ? error : new Option(error)),
        [error]
    );

    return <Maybe value={optValue}>{(error) => <p className="red error">{error}</p>}</Maybe>;
}
